import React, { useContext } from 'react';
import styles from './MovieButton.module.scss';
import MovieModal from '../modal/MovieModal';
import { ModalDispatchContext } from '../../contexts/ModalProvider';

const MovieButton: React.FC = () => {
  const setModal = useContext(ModalDispatchContext);
  const youtubeId = process.env.REACT_APP_YOUTUBE_ID;
  const showMovieModal = () => {
    setModal(<MovieModal youtubeId={youtubeId} />);
  };

  return (
    <button type='button' className={styles.movie} onClick={showMovieModal}>
      <span className={styles.movie__icon}>
        <span className={styles.movie__circle}> </span>
        <span className={styles.movie__triangle}> </span>
      </span>
      <span className={styles.movie__title}>ホームページ制作</span>
      <span className={styles.movie__text}>解説動画公開中！</span>
    </button>
  );
};

export default MovieButton;
